import { IPcr } from '../../../features/pcr/store/pcr.types'
import { IDrainState } from '../../../features/procedures/drain/store/drain.types'
import Logger from '../../../services/logger.service'
import { setValueForPathWithCreate } from '../../object.util'

export const addDrainLocationAndIntercostalSpace = (pcr: any): IPcr => {
  try {
    if (pcr.patient?.drainStateList?.length && pcr.patient.drainStateList[0].location === undefined) {
      pcr.patient.drainStateList.forEach((drainState: IDrainState) => {
        setValueForPathWithCreate(drainState, 'location', null)
        setValueForPathWithCreate(drainState, 'intercostalSpace', null)
      })
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addDrainLocationAndIntercostalSpace: ${error}`)
    throw error
  }
}
